import { useQuery } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

export interface PriceModelHistoryRow {
  id: string;
  billingAccountId: string;
  oldPriceModel: string | null;
  newPriceModel: string;
  changedAt: string;
  changedBy: string | null;
  changedByUserName: string | null;
}

interface Props {
  billingAccountId?: string;
  // Gate the fetch until the modal actually opens.
  enabled?: boolean;
}

export const usePriceModelHistory = ({ billingAccountId, enabled = true }: Props) => {
  return useQuery({
    queryKey: ['billing-accounts/price-model-history', billingAccountId],
    // Unwrap the fetchAPI envelope so callers get PriceModelHistoryRow[] directly.
    queryFn: async (): Promise<PriceModelHistoryRow[]> => {
      const response = await fetchAPI<{ data: PriceModelHistoryRow[] }>({
        method: 'GET',
        route: `billing-accounts/${billingAccountId}/price-model-history`,
      });
      return response?.data?.data ?? [];
    },
    enabled: Boolean(billingAccountId) && enabled,
    // Every modal re-open shows fresh data. Overrides the global 5-min
    // staleTime — history is small (one row per tier change) and the user
    // typically opens the modal right after editing to verify the new row.
    staleTime: 0,
    refetchOnMount: 'always',
  });
};

export default usePriceModelHistory;
